import { defineComponent, inject, ref, computed, watch, onMounted, onBeforeUnmount, resolveComponent, openBlock, createElementBlock, createVNode, mergeProps, withModifiers, withCtx, createElementVNode, normalizeProps, guardReactiveProps, toDisplayString, createTextVNode, createBlock, createCommentVNode } from "vue";
import Joi from "joi";
import { tlds } from "@hapi/tlds";
import MPasswordField from "./constituants/MPasswordField.es.js";
import "../MalarkeyContactRosterItem.vue_vue_type_script_lang-89c5ac30.mjs";
import "../MalarkeyContactSearchItem.vue_vue_type_script_lang-f1ada97c.mjs";
import "../MalarkeyContactAvatar-1b079ba3.mjs";
import "../MalarkeyConversationListItem.vue_vue_type_script_lang-3da40755.mjs";
import "./constituants/MalarkeyChatInputForm.es.js";
import "../MalarkeyAttachmentPane.vue_vue_type_script_lang-d0f606dc.mjs";
import "../i18n-35335a5c.mjs";
import { i as isRecordObject } from "../helpers-674591c1.mjs";
import { u as useForm } from "../vee-validate.esm-8fad8707.mjs";
import { u as useDefaults, _ as _export_sfc } from "../_plugin-vue_export-helper-3194dc60.mjs";
import { g as getFormFieldValidator, v as vuetifyConfig, b as vuetifyOtpConfig } from "../_validators-f968e1a2.mjs";
import "../index-64135f7d.mjs";
import { b as boundUseI18n } from "../_i18n-e414d464.mjs";
import { b as isValidIdentityFeedback } from "../malarkeyTwilioAdapter-1c296255.mjs";
import "../event-socket/malarkeyEventSocketAdapter.es.js";
import { d as debug } from "../_debug-8b5c3032.mjs";
import "../otpauth.esm-675c01d0.mjs";
import "../sudo-bad5b55e.mjs";
import { d as defined } from "../flow-501bd5ba.mjs";
import "../MPasswordField.vue_vue_type_script_lang-baf1023a.mjs";
import "../_VTextField-74fe2c1a.mjs";
import "../index-dbde2d54.mjs";
import "../_density-8094aebe.mjs";
import "../_proxiedModel-031e293c.mjs";
import "../_commonjsHelpers-ca272635.mjs";
import "../index-13be80af.mjs";
import "../index-fd2245c5.mjs";
import "../_VListItem-508e4b13.mjs";
import "../_common-fcf3ef61.mjs";
import "../theme-96176369.mjs";
import "../getCurrentInstance-eec76705.mjs";
import "../index-38c53cf2.mjs";
import "../index-703c58ee.mjs";
const _sfc_main = defineComponent({
  name: "MalarkeyLogin",
  components: {
    MPasswordField
  },
  props: {
    /**
     * The type of user which will be viewing the login form. Possible values are `client` and `agent`.
     * Functionally, this makes no difference, but the default content will change slightly based on the type.
     * @values client, agent
     */
    type: {
      type: String,
      required: true
    },
    /**
     * The URL of the logo to display in the login form. Should be taken from the [Brand Customization](https://malarkey-nht4944308-docs-specifications-b4dbd3d5ebccbade87ad2c6.gitlab.io/ui/customization.html).
     */
    logo: {
      type: String,
      required: true
    },
    /**
     * The name used to represent the application itself
     */
    appName: {
      type: String,
      required: true
    },
    /**
     * The name of the brand to use in the helper text
     */
    brandName: {
      type: String,
      required: true
    },
    /**
     * Designates the border-radius applied to the component. This can be xs, sm, md, lg, xl or a numeric value.
     */
    cardBorder: {
      type: [String, Number, Boolean],
      default: false
    },
    /**
     * The background color of the form. Can be the name of a theme color, a Vuetify Material Design color, or a CSS color value.
     */
    cardBgColor: {
      type: String,
      default: "transparent"
    },
    /**
     * Designates an elevation applied to the form between 0 and 24. You can find more information in the [Vuetify elevation documentation](https://vuetifyjs.com/en/styles/elevation/).
     */
    cardElevation: {
      type: [String, Number],
      default: void 0
    },
    /**
     * Removes the form's elevation.
     */
    cardFlat: {
      type: Boolean,
      default: false
    },
    /**
     * Apply a specific background image to the form.
     */
    cardBackgroundImage: {
      type: String,
      default: void 0
    },
    /**
     * Designates the border-radius applied to the form. This can be 0, xs, sm, true, lg, xl, pill, circle, and shaped. Find more information on available border radius classes in the [Vuetify Border Radius documentation](https://vuetifyjs.com/en/styles/border-radius/).
     */
    cardRounded: {
      type: [Boolean, Number, String],
      default: void 0
    },
    /**
     * Removes any applied border-radius from the form.
     */
    cardTile: {
      type: Boolean,
      default: false
    },
    /**
     * Applies a distinct style to the form.
     * Options are `text`, `flat`, `elevated`, `tonal`, `outlined`, and `plain`.
     */
    cardVariant: {
      type: String,
      default: "elevated"
    }
  },
  setup(props) {
    const { t } = boundUseI18n();
    const ls = inject("ls");
    const bus = inject("bus");
    const identity = inject("identity");
    const http = inject("http");
    const alert = inject("alert");
    const alertFromApiResponse = inject(
      "alertFromApiResponse"
    );
    const mounted = ref(false);
    const otpInput = ref(null);
    const authenticated = computed(() => {
      if (!mounted.value || !identity) {
        return null;
      }
      if (!identity.authenticated.value) {
        return false;
      }
      return identity.authenticated.value;
    });
    const preventContextMenu = (event) => {
      event.preventDefault();
      event.stopPropagation();
    };
    const propsWithDefaults = useDefaults(props, "MalarkeyLogin");
    const cardDefaults = useDefaults({}, "VCard");
    const cardBindings = computed(() => ({
      border: propsWithDefaults.cardBorder || cardDefaults.border,
      bgColor: propsWithDefaults.cardBgColor || cardDefaults.bgColor,
      elevation: propsWithDefaults.cardElevation || cardDefaults.elevation,
      flat: propsWithDefaults.cardFlat || cardDefaults.flat,
      backgroundImage: propsWithDefaults.cardBackgroundImage || cardDefaults.backgroundImage,
      rounded: propsWithDefaults.cardRounded || cardDefaults.rounded,
      tile: propsWithDefaults.cardTile || cardDefaults.tile,
      variant: propsWithDefaults.cardVariant || cardDefaults.variant,
      style: {
        position: "relative"
      },
      class: ["m-login"],
      tag: "form",
      action: "#",
      method: "post"
    }));
    const headerLogoContainerBindings = computed(() => ({
      class: [
        "m-login-logo-container",
        "d-flex",
        "justify-center",
        "align-center"
      ]
    }));
    const hintKey = computed(() => `malarkeyLogin.${props.type}.hint`);
    const mfaHintKey = computed(() => `malarkeyLogin.${props.type}.mfaHint`);
    const needsMFA = ref(false);
    const usernameFieldValidator = computed(() => {
      if (props.type === "client") {
        return getFormFieldValidator(
          t,
          Joi.string().required().email({
            minDomainSegments: 2,
            tlds: { allow: tlds }
          }),
          t(`malarkeyLogin.client.fields.username`)
        );
      } else {
        return getFormFieldValidator(
          t,
          Joi.string().required().min(3).custom((value, helpers) => {
            const { error } = Joi.string().email({
              minDomainSegments: 2,
              tlds: { allow: tlds }
            }).validate(value);
            if (!error) {
              return helpers.error("string.notEmail");
            }
            return value;
          }, "not-email"),
          t(`malarkeyLogin.agent.fields.username`)
        );
      }
    });
    const passwordFieldValidator = computed(
      () => getFormFieldValidator(
        t,
        Joi.string().required(),
        t(`malarkeyLogin.${props.type}.fields.password`)
      )
    );
    const mfaFieldValidator = computed(() => {
      if (needsMFA.value) {
        return getFormFieldValidator(
          t,
          Joi.string().required().min(6).max(6).pattern(/^[0-9]+$/, "string.numeric"),
          t(`malarkeyLogin.fields.otp`)
        );
      } else {
        return getFormFieldValidator(
          t,
          Joi.any().optional(),
          t(`malarkeyLogin.fields.otp`)
        );
      }
    });
    const {
      handleSubmit: handleFormSubmit,
      isSubmitting: formIsSubmitting,
      isValidating: formIsValidating,
      defineComponentBinds: defineFormComponentBinds,
      errors: formErrors,
      resetForm: resetFormFields,
      resetField: resetFormField,
      setFieldValue: setFormFieldValue,
      setFieldTouched: setFormFieldTouched,
      setTouched: setFormTouched,
      values: formValues
    } = useForm({
      initialValues: {
        username: "",
        password: "",
        otp: ""
      },
      validationSchema: {
        username: (val, ctx) => usernameFieldValidator.value(val, ctx),
        password: (val, ctx) => passwordFieldValidator.value(val, ctx),
        otp: (val, ctx) => mfaFieldValidator.value(val, ctx)
      }
    });
    const onMalarkeyLoginUsernameChanged = (username) => {
      setFormFieldValue("username", username);
    };
    const fieldsAreDisabled = computed(
      () => formIsSubmitting.value || authenticated.value ? true : false
    );
    const fieldsAreaClearable = computed(() => !fieldsAreDisabled.value);
    const fieldCommon = computed(() => ({
      disabled: fieldsAreDisabled.value,
      clearable: fieldsAreaClearable.value,
      autocapitalize: "off",
      spellcheck: false
    }));
    const textFieldDefaults = useDefaults({}, "VTextField");
    const usernameFieldDefaults = useDefaults(
      textFieldDefaults,
      "MalarkeyLoginUsernameField"
    );
    const passwordFieldGenericDefaults = useDefaults(
      textFieldDefaults,
      "MPasswordField"
    );
    const passwordFieldDefaults = useDefaults(
      passwordFieldGenericDefaults,
      "MalarkeyLoginPasswordField"
    );
    const otpInputDefaults = useDefaults({}, "VOtpInput");
    const otpFieldDefaults = useDefaults(
      otpInputDefaults,
      "MalarkeyLoginOTPField"
    );
    const usernameInFocus = ref(false);
    const passwordInFocus = ref(false);
    const otpInFocus = ref(false);
    const usernameComponentBinds = defineFormComponentBinds(
      "username",
      (state) => vuetifyConfig(state, usernameInFocus.value)
    );
    const passwordComponentBinds = defineFormComponentBinds(
      "password",
      (state) => vuetifyConfig(state, passwordInFocus.value)
    );
    const otpComponentBinds = defineFormComponentBinds(
      "otp",
      (state) => vuetifyOtpConfig(state, otpInFocus.value)
    );
    const form = computed(() => ({
      username: {
        ...usernameComponentBinds.value,
        ...usernameFieldDefaults,
        ...fieldCommon.value,
        label: t(`malarkeyLogin.${props.type}.fields.username`),
        onFocus: () => {
          usernameInFocus.value = true;
        },
        onBlur: () => {
          usernameInFocus.value = false;
          usernameComponentBinds.value.onBlur();
        },
        autocomplete: "username"
      },
      password: {
        ...passwordFieldDefaults,
        ...passwordComponentBinds.value,
        ...fieldCommon.value,
        label: t(`malarkeyLogin.${props.type}.fields.password`),
        onFocus: () => {
          passwordInFocus.value = true;
        },
        onBlur: () => {
          passwordInFocus.value = false;
          passwordComponentBinds.value.onBlur();
        },
        autocomplete: "current-password"
      },
      otp: {
        ...otpComponentBinds.value,
        ...otpFieldDefaults,
        ...fieldCommon.value,
        label: t(`malarkeyLogin.fields.otp`),
        "onUpdate:focused": (isFocused) => {
          otpInFocus.value = isFocused;
        }
      }
    }));
    const isSubmitting = ref(false);
    let submissionAbortController = new AbortController();
    const onValidIdentity = (bearer, expiration, id, type, username) => {
      identity.login(bearer, expiration, {
        id,
        type,
        username
      });
      if (needsMFA.value) {
        needsMFA.value = false;
      }
      resetFormField("password");
      resetFormField("otp");
      setFormFieldTouched("username", false);
      setFormFieldTouched("password", false);
      setFormFieldTouched("otp", false);
      setFormTouched(false);
    };
    const submitForm = handleFormSubmit(
      async (values) => {
        if (isSubmitting.value || !values)
          return;
        if (submissionAbortController) {
          submissionAbortController.abort();
        }
        submissionAbortController = new AbortController();
        submissionAbortController.signal.addEventListener("abort", () => {
          isSubmitting.value = false;
        });
        isSubmitting.value = true;
        if (!http || !identity) {
          await alert(
            "errors.vueInjectionMissing.title",
            "errors.vueInjectionMissing.text"
          );
        } else {
          try {
            const { status, data } = await http.post(
              "/identity",
              { ...values },
              {
                signal: submissionAbortController.signal,
                validateStatus: () => true
              }
            );
            if (201 === status && isRecordObject(data) && "data" in data && isValidIdentityFeedback(data.data)) {
              const {
                bearer,
                expiration,
                identity: id,
                type,
                username
              } = data.data;
              onValidIdentity(bearer, expiration, id, type, username);
            } else if (417 === status && isRecordObject(data) && "data" in data && isValidIdentityFeedback(data.data)) {
              const {
                bearer,
                expiration,
                identity: id,
                type,
                username
              } = data.data;
              if (username === values.username) {
                onValidIdentity(bearer, expiration, id, type, username);
              } else {
                await alert(
                  "errors.authenticated.is.title",
                  "errors.authenticated.is.text"
                );
              }
            } else {
              switch (status) {
                case 200:
                case 201:
                  await alert(
                    "errors.invalidIdentityFeedback.title",
                    "errors.invalidIdentityFeedback.text"
                  );
                  break;
                case 428:
                  needsMFA.value = true;
                  break;
                default:
                  await alertFromApiResponse(
                    data,
                    "malarkeyLogin.errors.loginSubmit",
                    {
                      app: props.appName,
                      brand: props.brandName
                    },
                    {
                      username: form.value.username.label,
                      password: form.value.password.label,
                      otp: form.value.otp.label
                    },
                    () => {
                      defined(otpInput, void 0, [
                        null
                      ]).then((elem) => {
                        if (elem) {
                          elem.focus();
                        }
                      });
                    }
                  );
                  break;
              }
            }
          } catch {
            await alert("errors.httpCaught.title", "errors.httpCaught.text");
          }
        }
        isSubmitting.value = false;
      }
    );
    const submit = (event) => {
      event.preventDefault();
      submitForm();
    };
    const formIsProcessing = computed(
      () => formIsSubmitting.value || isSubmitting.value
    );
    const btnDefaults = useDefaults({}, "VBtn");
    const submitBtnDefaults = useDefaults(
      btnDefaults,
      "MalarkeyLoginSubmitBtn"
    );
    const submitBtnBindings = computed(() => ({
      ...submitBtnDefaults,
      type: "submit",
      loading: formIsProcessing.value,
      disabled: authenticated.value
    }));
    const resetBtnDefaults = useDefaults(btnDefaults, "MalarkeyLoginResetBtn");
    const resetBtnBindings = computed(() => ({
      ...resetBtnDefaults,
      type: "reset",
      loading: formIsProcessing.value,
      disabled: authenticated.value
    }));
    const resetOtpField = (e) => {
      e.preventDefault();
      e.stopPropagation();
      resetFormField("otp");
      setFormFieldTouched("otp", false);
      defined(otpInput, void 0, [null]).then((elem) => {
        if (elem) {
          elem.focus();
        }
      });
    };
    const mfaDialogBindings = computed(() => ({
      closeOnBack: false,
      closeOnContentClick: false,
      contained: true,
      maxWidth: 400,
      retainFocus: false,
      persistent: true
    }));
    const mfaDialogCardDefaults = useDefaults(
      cardDefaults,
      "MalarkeyLoginTwoFactorDialog"
    );
    const mfaDialogCardBindings = computed(() => ({
      ...mfaDialogCardDefaults,
      class: ["m-login-mfa-dialog"]
    }));
    const closeMfaDialog = () => {
      needsMFA.value = false;
    };
    watch(
      () => mounted.value,
      (is) => {
        if (is) {
          if (bus) {
            bus.on(
              "malarkey-login:username:changed",
              onMalarkeyLoginUsernameChanged,
              { crossTab: true, local: true }
            );
          }
          if (ls) {
            const username = ls.get("malarkey-login:username");
            if (username) {
              debug("retrieved username from local storage");
              setFormFieldValue("username", username);
            }
          }
        }
        if (!is) {
          if (bus) {
            bus.off(
              "malarkey-login:username:changed",
              onMalarkeyLoginUsernameChanged,
              { crossTab: true, local: true }
            );
          }
        }
      },
      { immediate: true }
    );
    watch(
      () => formValues.username,
      (is) => {
        if (ls) {
          ls.set("malarkey-login:username", is);
        }
        if (bus) {
          bus.emit(
            "malarkey-login:username:changed",
            {
              crossTab: true,
              local: true
            },
            is
          );
        }
      }
    );
    watch(
      () => needsMFA.value,
      (is) => {
        if (!is) {
          resetFormField("otp");
          setFormFieldTouched("otp", false);
        } else {
          defined(otpInput, void 0, [null]).then((elem) => {
            if (elem) {
              elem.focus();
            }
          });
        }
      }
    );
    onMounted(() => {
      console.log(form.value.password);
      mounted.value = true;
    });
    onBeforeUnmount(() => {
      mounted.value = false;
    });
    return {
      otpInput,
      preventContextMenu,
      cardBindings,
      headerLogoContainerBindings,
      hintKey,
      mfaHintKey,
      submit,
      form,
      formIsProcessing,
      formIsValidating,
      resetFormFields,
      resetFormField,
      formErrors,
      formValues,
      setFormFieldTouched,
      setFormTouched,
      submitBtnBindings,
      needsMFA,
      mfaDialogBindings,
      mfaDialogCardBindings,
      closeMfaDialog,
      resetBtnBindings,
      resetOtpField
    };
  }
});
const _hoisted_1 = /* @__PURE__ */ createElementVNode("input", {
  type: "submit",
  name: "_submit",
  style: { "display": "none" }
}, null, -1);
const _hoisted_2 = ["src", "alt"];
const _hoisted_3 = { class: "m-login-title-content m-font-heading" };
const _hoisted_4 = ["textContent"];
const _hoisted_5 = ["textContent"];
function _sfc_render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_v_toolbar_title = resolveComponent("v-toolbar-title");
  const _component_v_toolbar = resolveComponent("v-toolbar");
  const _component_i18n_t = resolveComponent("i18n-t");
  const _component_v_card_text = resolveComponent("v-card-text");
  const _component_v_text_field = resolveComponent("v-text-field");
  const _component_v_col = resolveComponent("v-col");
  const _component_v_row = resolveComponent("v-row");
  const _component_MPasswordField = resolveComponent("MPasswordField");
  const _component_v_btn = resolveComponent("v-btn");
  const _component_v_container = resolveComponent("v-container");
  const _component_v_chip = resolveComponent("v-chip");
  const _component_v_icon = resolveComponent("v-icon");
  const _component_v_toolbar_items = resolveComponent("v-toolbar-items");
  const _component_v_divider = resolveComponent("v-divider");
  const _component_v_otp_input = resolveComponent("v-otp-input");
  const _component_v_card = resolveComponent("v-card");
  const _component_v_dialog = resolveComponent("v-dialog");
  return openBlock(), createElementBlock("div", null, [
    createVNode(_component_v_card, mergeProps(_ctx.cardBindings, {
      onSubmit: withModifiers(_ctx.submit, ["stop"])
    }), {
      default: withCtx(() => [
        _hoisted_1,
        createElementVNode("header", normalizeProps(guardReactiveProps(_ctx.headerLogoContainerBindings)), [
          createElementVNode("img", {
            src: _ctx.logo,
            alt: _ctx.$t("general.logo", { brand: _ctx.brandName }),
            role: "img",
            onContextmenu: _cache[0] || (_cache[0] = (...args) => _ctx.preventContextMenu && _ctx.preventContextMenu(...args))
          }, null, 40, _hoisted_2)
        ], 16),
        createVNode(_component_v_toolbar, {
          color: "transparent",
          flat: "",
          density: "compact"
        }, {
          default: withCtx(() => [
            createVNode(_component_v_toolbar_title, { class: "m-login-title" }, {
              default: withCtx(() => [
                createElementVNode("span", _hoisted_3, toDisplayString(_ctx.appName), 1)
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        createVNode(_component_v_card_text, { class: "m-login-hint" }, {
          default: withCtx(() => [
            createVNode(_component_i18n_t, {
              keypath: _ctx.hintKey,
              tag: "span"
            }, {
              bold: withCtx(() => [
                createElementVNode("strong", {
                  textContent: toDisplayString(_ctx.brandName),
                  class: "m-login-hint-brand"
                }, null, 8, _hoisted_4)
              ]),
              _: 1
            }, 8, ["keypath"])
          ]),
          _: 1
        }),
        createVNode(_component_v_container, null, {
          default: withCtx(() => [
            createVNode(_component_v_row, null, {
              default: withCtx(() => [
                createVNode(_component_v_col, { cols: "12" }, {
                  default: withCtx(() => [
                    createVNode(_component_v_text_field, normalizeProps(guardReactiveProps(_ctx.form.username)), null, 16)
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            createVNode(_component_v_row, null, {
              default: withCtx(() => [
                createVNode(_component_v_col, { cols: "12" }, {
                  default: withCtx(() => [
                    createVNode(_component_MPasswordField, normalizeProps(guardReactiveProps(_ctx.form.password)), null, 16)
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            createVNode(_component_v_row, null, {
              default: withCtx(() => [
                createVNode(_component_v_col, {
                  cols: "12",
                  class: "d-flex justify-end"
                }, {
                  default: withCtx(() => [
                    createVNode(_component_v_btn, normalizeProps(guardReactiveProps(_ctx.submitBtnBindings)), {
                      default: withCtx(() => [
                        createTextVNode(toDisplayString(_ctx.$t("malarkeyLogin.general.login")), 1)
                      ]),
                      _: 1
                    }, 16)
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        createVNode(_component_v_dialog, mergeProps({
          modelValue: _ctx.needsMFA,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event) => _ctx.needsMFA = $event)
        }, _ctx.mfaDialogBindings), {
          default: withCtx(() => [
            createVNode(_component_v_card, normalizeProps(guardReactiveProps(_ctx.mfaDialogCardBindings)), {
              default: withCtx(() => [
                createVNode(_component_v_toolbar, {
                  color: "transparent",
                  flat: "",
                  density: "compact",
                  class: "m-2fa-title"
                }, {
                  default: withCtx(() => [
                    createVNode(_component_v_toolbar_title, { class: "m-2fa-title-content m-font-heading" }, {
                      default: withCtx(() => [
                        createElementVNode("small", null, toDisplayString(_ctx.$t("malarkeyLogin.twoFactorDialog.title")), 1),
                        createVNode(_component_v_chip, {
                          color: "success",
                          class: "ms-2",
                          size: "small",
                          variant: "flat"
                        }, {
                          default: withCtx(() => [
                            createTextVNode(toDisplayString(_ctx.$t("malarkeyLogin.twoFactorDialog.abbreviation")), 1)
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }),
                    createVNode(_component_v_toolbar_items, null, {
                      default: withCtx(() => [
                        createVNode(_component_v_btn, {
                          icon: "",
                          onClick: _ctx.closeMfaDialog,
                          "aria-label": _ctx.$t("$vuetify.confirmEdit.cancel")
                        }, {
                          default: withCtx(() => [
                            createVNode(_component_v_icon, null, {
                              default: withCtx(() => [
                                createTextVNode("mdi-close")
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }, 8, ["onClick", "aria-label"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                createVNode(_component_v_divider),
                createVNode(_component_v_card_text, { class: "m-2fa-hint" }, {
                  default: withCtx(() => [
                    createVNode(_component_i18n_t, {
                      keypath: _ctx.mfaHintKey,
                      tag: "span"
                    }, {
                      bold: withCtx(() => [
                        createElementVNode("strong", {
                          textContent: toDisplayString(_ctx.brandName),
                          class: "m-2fa-hint-brand"
                        }, null, 8, _hoisted_5)
                      ]),
                      _: 1
                    }, 8, ["keypath"])
                  ]),
                  _: 1
                }),
                createVNode(_component_v_container, null, {
                  default: withCtx(() => [
                    createVNode(_component_v_row, null, {
                      default: withCtx(() => [
                        createVNode(_component_v_col, {
                          cols: "12",
                          class: "d-flex justify-center"
                        }, {
                          default: withCtx(() => [
                            createVNode(_component_v_otp_input, mergeProps(_ctx.form.otp, { ref: "otpInput" }), null, 16)
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }),
                    createVNode(_component_v_row, null, {
                      default: withCtx(() => [
                        createVNode(_component_v_col, {
                          cols: "12",
                          class: "d-flex justify-end"
                        }, {
                          default: withCtx(() => [
                            "string" === typeof _ctx.formValues.otp && _ctx.formValues.otp.trim().length > 0 ? (openBlock(), createBlock(_component_v_btn, mergeProps({ key: 0 }, _ctx.resetBtnBindings, {
                              onClick: _ctx.resetOtpField,
                              class: "me-2"
                            }), {
                              default: withCtx(() => [
                                createTextVNode(toDisplayString(_ctx.$t("malarkeyLogin.general.clear")), 1)
                              ]),
                              _: 1
                            }, 16, ["onClick"])) : createCommentVNode("", true),
                            createVNode(_component_v_btn, normalizeProps(guardReactiveProps(_ctx.submitBtnBindings)), {
                              default: withCtx(() => [
                                createTextVNode(toDisplayString(_ctx.$t("malarkeyLogin.general.submit")), 1)
                              ]),
                              _: 1
                            }, 16)
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 16)
          ]),
          _: 1
        }, 16, ["modelValue"])
      ]),
      _: 1
    }, 16, ["onSubmit"])
  ]);
}
const MalarkeyLogin = /* @__PURE__ */ _export_sfc(_sfc_main, [["render", _sfc_render], ["__file", "MalarkeyLogin.vue"]]);
export {
  MalarkeyLogin as default
};
//# sourceMappingURL=MalarkeyLogin.es.js.map
